<template>

<div>
	<collapsible-panel v-if="filteringTools" :external-toggle="panelToggled" v-on:panelRetract="panelToggled = false">
		<template slot="panel">

			<h4>Filtering</h4>

			<template v-if="showJob">

				<field label="Log Type" col-class="stacked" :params="{type:'btn-group',buttons: [
						{value: 'all',text: 'All'},
						{value: 'projects',text: 'Projects'},
						{value: 'services',text: 'Services'}
					]}"
					v-model="filterValues.log_type"
					v-on:change="fetchTimeLogs">
				</field>

				<job-picker
					v-if="filterValues && filterValues.log_type == 'projects'"
					col-class="stacked" 
					v-model="filterValues.job_id"
					job-type="project"
					key="project"
					v-on:change="fetchTimeLogs">
				</job-picker>

				<job-picker
					v-if="filterValues && filterValues.log_type == 'services'"
					col-class="stacked" 
					v-model="filterValues.service_id"
					job-type="service"
					key="service"
					v-on:change="fetchTimeLogs">
				</job-picker>

			</template>

			<!--
			<field label="Customer" 
				col-class="stacked" 
				v-on:change="fetchTimeLogs" 
				v-model="filterValues.customer_name_cache" 
				:params="{type:'select',options: customerOptions}">		
			</field>
			-->

			<field v-if="showUser" 
				label="Employee" 
				col-class="stacked" 
				v-on:change="fetchTimeLogs" 
				v-model="filterValues.user_id" 
				:params="{type:'select',options: employeesOptions}">		
			</field>

			<field v-if="showUserClassification" 
				label="Employee Classification" 
				col-class="stacked" 
				v-on:change="fetchTimeLogs" 
				v-model="filterValues.classification_id" 
				:params="{type:'select',options: classificationsOptions}">
			</field>

			<field label="Status" col-class="stacked" :params="{type: 'select',options: [
				{text: 'All',value:'all'},
				{text: 'Unreviewed',value:'unreviewed'},
				{text: 'Reviewed',value:'reviewed'},
				{text: 'Submitted',value:'submitted'}
			]}" v-model="filterValues.status" v-on:change="fetchTimeLogs"></field>

			<form-group label="Reported Hours Range (from-to)" col-class="stacked">
				<div class="d-flex flex-row">

					<field v-on:change="fetchTimeLogs" v-model="filterValues.hrsFrom" :params="{type:'number',min:0,step:0.25}"></field>

					<field v-on:change="fetchTimeLogs" v-model="filterValues.hrsTo" :params="{type:'number',min:filterValues.hrsFrom,step:0.25}"></field>

				</div>
			</form-group>

			<form-group label="Date Range (from-to)" col-class="stacked">
				<div class="d-flex flex-row">

					<field v-on:change="fetchTimeLogs" v-model="filterValues.dateFrom" :params="{type:'date'}"></field>

					<field v-on:change="fetchTimeLogs" v-model="filterValues.dateTo" :params="{type:'date'}"></field>

				</div>

			</form-group>

			<field  label="Clock-in Location" col-class="stacked" v-on:change="fetchTimeLogs" v-model="filterValues.onSiteStatus" :params="{type:'btn-group',buttons: onsiteButtons}"></field>

		</template>
		<template slot="heading">
			<slot></slot>
		</template>
		<template slot="main">

			<h2 v-if="heading">
				{{heading}}
				<template v-if="headingSmall">
					<br>
					<small>{{headingSmall}}</small>
				</template>
			</h2>

			<!--values: {{projectTotalsValues}}
			labels: {{projectLabels}}
			<chart
				v-if="mutatedLogs.length > 1"
				:key="chartKey"
				:height="chartHeight"
				type="horizontalBar"
				:labels="projectLabels"
				:data="projectTotalsValues"
				label="Total Hours By Project"
				background-color="#70b4ff"
				border-color="#70b4ff"
				border-width="0">
			</chart>-->

			<table-list v-if="windowWidth > 800"
				key="timeLogList"
				:loading="loading"
				:mobile-breakpoint="800"
				:records="timeLogs"
				:fields="mutatedFields"
				record-name="Time Log"
				:has-edit="editable"
				record-locked-property="locked"
				v-on:otherButtonClick="viewTimeLog"
				:other-buttons='[
					{text: "View",icon:"fa-eye",click: "viewTimeLog",class: "btn-primary"}
				]'
				id-field="slug"
				:sortable="true"
				:total-paginated-records="totalRecords"
				v-on:edit="editRecord">

				<button :disabled="panelToggled" class="btn btn-light" v-on:click="panelToggled = true">
					<i class="fa fa-filter"></i>
					Filter
				</button>

				<button class="btn btn-light ml-2" v-on:click="exportLogs" :disabled="exportingLogs">
					<i class="fa fa-download"></i>
					Export All as CSV
				</button>

			</table-list>

			<template v-else>

				<button :disabled="panelToggled" class="btn btn-light" v-on:click="panelToggled = true">
					<i class="fa fa-filter"></i>
					Filter
				</button>

				<button class="btn btn-light ml-2" v-on:click="exportLogs" :disabled="exportingLogs">
					<i class="fa fa-download"></i>
					Export All as CSV
				</button>
				
				<time-log-list-card v-for="(log,index) in timeLogs"
					:key="index"
					:fields="mutatedFields"
					:timelog="log"
					v-on:click="editRecord(log)">
				</time-log-list-card>

			</template>

			<pagination :current-page="page" :pages="numPages" v-on:pageChange="pageChange"></pagination>

		</template>
	</collapsible-panel>

	<template v-else>
		<template slot="heading">
			<slot></slot>
		</template>

		<template slot="main">

			<h2 v-if="heading">{{heading}}</h2>

			<!--<chart
				v-if="mutatedLogs.length > 1"
				:key="chartKey"
				:height="chartHeight"
				type="horizontalBar"
				:labels="projectLabels"
				:data="projectTotalsValues"
				label="Total Hours By Project"
				background-color="#70b4ff"
				border-color="#70b4ff"
				border-width="0">
			</chart>-->



			<table-list v-if="windowWidth > 800"
				key="timeLogList"
				:loading="loading"
				:records="timeLogs"
				:fields="mutatedFields"
				record-name="Time Log"
				record-locked-property="locked"
				:has-edit="editable"
				:other-buttons='[
					{text: "View",icon:"fa-eye",click: "viewTimeLog",class: "btn-primary"}
				]'
				v-on:otherButtonClick="viewTimeLog"
				:total-paginated-records="totalRecords"
				:sortable="true"
				id-field="slug"
				v-on:edit="editRecord">

				<button :disabled="panelToggled" class="btn btn-light" v-on:click="panelToggle = true">
					<i class="fa fa-filter"></i>
					Filter
				</button>



			</table-list>

			<template v-else>

				<button :disabled="panelToggled" class="btn btn-light" v-on:click="panelToggled = true">
					<i class="fa fa-filter"></i>
					Filter
				</button>

				<button class="btn btn-light ml-2" v-on:click="exportLogs" :disabled="exportingLogs">
					<i class="fa fa-download"></i>
					Export All as CSV
				</button>
				
				<time-log-list-card v-for="(log,index) in timeLogs"
					:key="index"
					:fields="mutatedFields"
					:timelog="log"
					v-on:click="editRecord(log)">
				</time-log-list-card>

			</template>

			<pagination :current-page="page" :pages="numPages" v-on:pageChange="pageChange"></pagination>

		</template>
	</template>

	<time-log-edit-modal
		:visible="editModal.visible"
		:record="editModal.record"
		:show-transfer-button="false"
		:time-log-settings="$store.timeLogSettings"
		:allow-job-edit="true"
		:view-only="editModal.viewMode"
		:has-comments="true"
		:show-reviewed-button="showReviewButton"
		v-on:closeModal="editModal.visible = false"
		v-on:save="save"
		v-on:modelChanged="fetchTimeLogs">
	</time-log-edit-modal>

</div>

</template>

<script>
import TableList from "../TableList"
import Field from "../Field"
import FormGroup from "../FormGroup"
import CollapsiblePanel from "../../layout_fragments/CollapsiblePanel"
import TimeLogEditModal from "./TimeLogEditModal"
import Pagination from "../Pagination"
import Chart from "../Chart"
import TimeLogListCard from "@/components/TimeLogListCard"

import JobPicker from "@/components/super_components/JobPicker"


export default {

	name: 'TimeLogTable',
	components: {
		TableList,
		Field,
		FormGroup,
		CollapsiblePanel,
		TimeLogEditModal,
		Pagination,
		Chart,
		JobPicker,
		TimeLogListCard
	},
	props: [
		"heading", //main h2 heading above table
		"headingSmall",
		"showUser", //show user's name as a column,
		"showJob", //show project name as a column,
		"showUserClassification", //show user's classification as a column,
		"showPay", //show user's pay amount for that time block
		"blockFetches", //if false, AJAX calls will be blocked until it becomes true
		"editable", //if false, edit controls will not appear,
		"filteringTools", //show filtering tools,
		"filters", //pass in enforced filters
		"defaultFilterValues", //not enforced, but set up as defaults. Supports job_id, user_id, dateFrom, dateTo, hrsFrom, hrsTo
		"projectId",
		"serviceId"
	],
	data() {
		return {
			panelToggled: false,
			totalRecords: 0,
			editModal: {
				visible: false,
				viewMode: false,
				payload: {},
				record: {}
			},
			/*viewModal: {
				visible: false,
				record: {}
			},*/
			filterPanelRetracted: false,
			timeLogs: [],
			page: 1,
			numPages: 0,
			filterValues: {
				log_type: 'all',
				job_id: this.getInitial("job_id"),
				service_id: this.getInitial("service_id"),
				user_id: this.getInitial("user_id"),
				classification_id: this.getInitial("classification_id"),
				dateFrom: this.getInitial("dateFrom") ? this.getInitial("dateFrom") : this.moment().format("YYYY-MM-DD"),
				dateTo: this.getInitial("dateTo"),
				onSiteStatus: "all",
				status: "all",
				hrsFrom: this.getInitial("hrsFrom"),
				hrsTo: this.getInitial("hrsTo"),
				customer_name_cache: ''
			},
			filterValueSet: false,
			filterDefaultsReady: false,
			employeesOptions: [],
			customers: [],
			classificationsOptions: [],
			userRoles: [],
			onsiteButtons: [
				{text: "All",value:"all"},
				{text: "Onsite",value:"onsite"},
				{text: "Offsite",value:"offsite"}
			],
			timeLogIncludes: [
				{model:"User", include:["EmployeeClassification"]},
				{model: "Job", fields: ["id","slug","job_num","job_name","lat","long","detailed_timelogs","detailed_timelogs_depth"]},
				{model: "Service", fields: ["id","slug","job_num","job_name","lat","long"]},
				{model: "PayBoost",fields: ["id","slug","description"]},
				{model: "JobChangeOrder",fields: ["id","slug","quote_num"]}
			],
			fields: [
				{label: "Time In",key: "timeIn",sortBy:"date",align: "right"},
				{label: "Clock In Remarks", key: "time_in_notes",showOnMobile: false},
				{label: "On Site",key:"timeOnSite",align:"right",showOnMobile:false},
				{label: "Time Out",key: "timeOut",align: "right",showOnMobile:false},
				{label: "Clock Out Remarks", key: "time_out_notes",showOnMobile: false},
				{label: "In/Out Diff",key: "timeDiff",align: "center",showOnMobile:false},
				{label: "Reported Hrs",key: "regular_hours",align: "right"},
				{label: "Overtime",key: "overtime_hrs",align: "right",showOnMobile:false},
				{label: "Onsite",key: "wasOnsite",align: "center",showOnMobile:false},
				{label: "Reason Not On Site",key: "reason_not_on_site",showOnMobile:false}
			],
			loading: true,
			chartKey: Math.random(),
			exportingLogs: false
		}
	},
	watch: {
		blockFetches() {
			if (!this.blockFetches && this.filterDefaultsReady)
				this.fetchTimeLogs()
		},
		defaultFilterValues() {
			let vm = this
			
			if (!this.filterValueSet) {
				Object.keys(this.defaultFilterValues).forEach(key => {
					vm.filterValues[key] = vm.defaultFilterValues[key]
				})
				this.filterValueSet = true
			}
		}
	},
	computed: {
		windowWidth() {
			return window.innerWidth
		},
		needToFetchDirectLog() {
			return this.$route.name == 'TimeLogsWithSlug' && "slug" in this.$route.params && this.$route.params.slug
		},
		showReviewButton() {
			if (this.serviceId > 0 || this.projectId > 0) {
				let reviewTimeLogsRole = this.userRoles.find(role => {
					if ("JobPersonnelRole" in role && role.JobPersonnelRole) {
						if (role.JobPersonnelRole.review_timelogs == 1)
							return true
					}
					return false
				})

				if (reviewTimeLogsRole)
					return true
			}
			
			return false
		},
		customerOptions() {
			return this.$store.customers.map(customer => {
				return {
					text: customer.name,
					value: customer.name
				}
			})
		},
		projectTotals() {
			let projects = {}

			let vm = this

			vm.timeLogs.forEach(log => {

				let logTotal = parseFloat(log['regular_hours']) + parseFloat(log['overtime_hours_15x']) + parseFloat(log['overtime_hours_2x']) + parseFloat(log['overtime_hours_25x'])

				if (log.Job && Object.keys(log.Job).length > 0) {
					let jobName = log.Job.job_num+": "+log.Job.job_name

					if (jobName.length > 40)
						jobName = jobName.substring(1,40)+"..."

					//check if this job is in projects obj
					if (!(jobName in projects))
						vm.$set(projects,jobName, 0)

					projects[jobName] += logTotal
				}
				else if (log.Service && Object.keys(log.Service).length > 0) {
					let jobName = log.Service.job_num+": "+log.Service.job_name

					if (jobName.length > 40)
						jobName = jobName.substring(1,40)+"..."

					//check if this job is in projects obj
					if (!(jobName in projects))
						vm.$set(projects,jobName, 0)

					projects[jobName] += logTotal
				}
			})

			//check if there are more than 10 projects listed, amalgomate the smaller ones into a "misc" job
			if (Object.keys(projects).length > 10) {
				Object.keys(projects).forEach(key => {
					if (projects[key] < 10) {
						if (!("Miscellaneous" in projects))
							vm.$set(projects,'Miscellaneous',0)

						projects.Miscellaneous += projects[key]

						delete projects[key]
					}

				})
			}

			this.chartKey = Math.random()

			return projects
		},
		projectLabels() {
			return Object.keys(this.projectTotals)
		},
		projectTotalsValues() {
			let values = []
			let vm = this

			Object.keys(this.projectTotals).forEach(key => {
				values.push(vm.projectTotals[key])
			})

			return values
		},
		chartHeight() {

			let height

			if (window.innerWidth < 500)
				height = (Object.keys(this.projectTotals).length * 30) + 50

			else
				height = (Object.keys(this.projectTotals).length * 20) + 50

			return height
		},
		jobLocation() {
			let markers = []

			let jobType = "Job"
			if ("Service" in this.viewModal.record && this.viewModal.Service)
				jobType = "Service"

			if (jobType in this.viewModal.record && this.viewModal.record[jobType]) {

				return {
					lat: +this.viewModal.record[jobType].lat,
					lng: +this.viewModal.record[jobType].long,
					icon: window.apiRoot+"resources/icons/hardhat_36_point.png"
				}
			}
			else {
				return {
					lat: 0,
					lng: 0
				}
			}
		},
		checkInTolerance() {
			let jobType = "Job"
			if ("Service" in this.viewModal.record)
				jobType = "Service"

			if (jobType in this.viewModal.record && this.viewModal.record[jobType])
				return parseFloat(this.viewModal.record[jobType].check_in_tolerance)
		},
		initialFromDate() {
			//calculate 1st of month
			return this.moment().subtract(1,"days").format("YYYY-MM-DD")
		},
		mutatedFields() {
			let fields = this.cloneObj(this.fields)

			if (this.showJob) {
				fields.unshift({
					label: "Project/Service",
					key: "projectName",
					showOnMobile:false
				})
			}
			if (this.showUserClassification) {
				fields.unshift({
					label: "Employee Classification",
					key: "classification",
					showOnMobile:false
				})
			}
			if (this.showUser) {
				fields.unshift({
					label: "Employee",
					key: "userFullName",
					type: "link"
				})
			}
			fields.unshift({
				label: "Customer",
				key: "customerName"
			})
			
			if (this.showPay) {
				fields.push({
					label: "Pay",
					key: "payAmount"
				})
			}

			if (this.qboIsActive) {
				fields.push({
					label: "Pushed to QBO",
					key: 'pushedToQBO'
				})
			}

			return fields
		},
	},
	methods: {
		compileFilters() {
			let vm = this

			let filters = []

			//add filters passed in through props
			if (typeof vm.filters != "undefined" && vm.filters.length > 0)
				filters = JSON.parse(JSON.stringify(vm.filters))

			if (vm.filterValues.log_type == 'services') {
				filters.push(["service_id >",0])

				if (vm.filterValues.service_id)
					filters.push(["service_id",vm.filterValues.service_id])
			}
			else if (vm.filterValues.log_type == 'projects') {
				filters.push(["job_id >",0])

				if (vm.filterValues.job_id)
					filters.push(["job_id",vm.filterValues.job_id])
			}

			if (vm.filterValues.user_id)
				filters.push(["user_id",vm.filterValues.user_id])

			if (vm.filterValues.dateFrom) {
				let dateFromUtc = vm.moment(vm.filterValues.dateFrom + " 00:00:00").utc().format("YYYY-MM-DD HH:mm:ss")
				filters.push(["time_in >=",dateFromUtc])
			}

			if (vm.filterValues.dateTo) {
				let dateToUtc = vm.moment(vm.filterValues.dateTo + " 23:59:59").utc().format("YYYY-MM-DD HH:mm:ss")
				filters.push(["time_in <=",dateToUtc])
			}

			if (vm.filterValues.status == "unreviewed")
				filters.push(["reviewed_by",0])
			else if (vm.filterValues.status == "reviewed")
				filters.push(["reviewed_by >",0])
			else if (vm.filterValues.status == "submitted")
				filters.push(["submitted_by >",0])

			if (vm.filterValues.hrsFrom)
				filters.push(["regular_hours >=",vm.filterValues.hrsFrom])
			if (vm.filterValues.hrsTo)
				filters.push(["regular_hours <=",vm.filterValues.hrsTo])

			return filters
		},
		mutateLogs(freshLogs) {
			let vm = this

			let totalDiff = 0
			let totalRegular = 0
			let total15x = 0
			let total2x = 0
			let total25x = 0

			freshLogs.forEach(log => {

				let jobType = "Service"
				if ("Job" in log && log.Job)
					jobType = "Job"

				if (vm.showJob) {
					log.projectName = ""

					if (jobType in log && log[jobType]) {
						log.projectName = log[jobType].job_num +": "+ log[jobType].job_name
					}
				}

				let distance
				log.onsiteBoolean = false
				log.onsiteClockoutBoolean = false
				log.wasOnsite = "<i class='fa fa-question'></i>";
				log.wasOnsiteClockout = "<i class='fa fa-question'></i>";

				if (jobType in log && log[jobType]) {

					if (log.lat != 0 && log.long != 0) {
						distance = this.getDistance(log[jobType].lat,log[jobType].long,log.lat,log.long)

						if (distance > log[jobType].check_in_tolerance) {
							log.onsiteBoolean = false
							log.wasOnsite = "<i class='fa fa-times'></i>";
						}
						else {
							log.onsiteBoolean = true
							log.wasOnsite = "<i class='fa fa-check'></i>";
						}
					}

					if (log.lat_clockout != 0 && log.long_clockout != 0) {
						distance = this.getDistance(log[jobType].lat,log[jobType].long,log.lat_clockout,log.long_clockout)
						if (distance > log[jobType].check_in_tolerance) {
							log.onsiteClockoutBoolean = false
							log.wasOnsiteClockout = "<i class='fa fa-times'></i>";
						}
						else{
							log.onsiteClockoutBoolean = true
							log.wasOnsiteClockout = "<i class='fa fa-check'></i>";
						}
					}
				}

				if (vm.showUser && log.User)
					log.userFullName = {
						link: "/employee/"+log.User.slug+"/profile",
						text: log.User.first_name+" "+log.User.last_name
					}
				else
					log.userFullName = {
						link: "",
						text: ""
					}

				if (vm.showUserClassification && typeof log.User.EmployeeClassification != "undefined") {
					log.classification = ""
					log.classification_id= null

					if (log.User.EmployeeClassification.length > 0) {
						log.classification = log.User.EmployeeClassification[0].title
						log.classification_id = log.User.EmployeeClassification[0].id
					}
				}
				else
					log.classification = ""

				if (vm.showPay) //needs to calculate base pay + any extra pays, times hours worked
					log.payAmount = "To-Do"

				log.timeIn = vm.formatDateTimeToLocal(log.time_in,'full-date-time')
				log.timeOut = vm.formatDateTimeToLocal(log.time_out,'time')
				log.timeOnSite = vm.formatDateTimeToLocal(log.time_on_site,'time')

				let timeDiff = vm.dateDiff(log.time_in,log.time_out,"hrs")

				log.timeDiff= isNaN(timeDiff) ? "[tbd]" : timeDiff;

				totalRegular += parseFloat(log.regular_hours)
				total15x += parseFloat(log.overtime_hours_15x)
				total2x += parseFloat(log.overtime_hours_2x)
				total25x += parseFloat(log.overtime_hours_25x)

				log.overtime_hrs = ""
				if (parseFloat(log.overtime_hours_15x) > 0)
					log.overtime_hrs += log.overtime_hours_15x + "hrs @1.5x "
				if (parseFloat(log.overtime_hours_2x) > 0)
					log.overtime_hrs += log.overtime_hours_2x + "hrs @2x "
				if (parseFloat(log.overtime_hours_25x) > 0)
					log.overtime_hrs += log.overtime_hours_25x + "hrs @2.5x "

				log.reviewedByName = log.ReviewedBy ? log.ReviewedBy.first_name+" "+log.ReviewedBy.last_name : "<i class='fa fa-times'></i>"
				log.submittedByName = log.SubmittedBy ? log.SubmittedBy.first_name + " " + log.SubmittedBy.last_name : "<i class='fa fa-times'></i>"

				//if (log.submitted_by > 0)
				//	log.locked = true

				log.pushedToQBO = '<i class="text-danger fa fa-times-circle" title="This time log should have been pushed to QB, but there was an error"></i>'
				if (log.qbo_ids_json)
					log.pushedToQBO = '<i class="text-success fa fa-check-circle" title="This time log has been pushed to QB"></i>'

				log.customerName = ""

				if ("Job" in log && log.Job && "customer_name_cache" in log.Job)
					log.customerName = log.Job.customer_name_cache
				else if ("Service" in log && log.Service && "customer_name_cache" in log.Service)
					log.customerName = log.Service.customer_name_cache

				//log.reason_not_on_site = log.reason_not_on_site.substring(0,15)+"..."
			})

			//add total row at bottom
			let overtime_combined = ""
			if (total15x > 0)
				overtime_combined += total15x + "hrs @1.5x "
			if (total2x > 0)
				overtime_combined += total2x + "hrs @2x "
			if (total25x > 0)
				overtime_combined += total25x + "hrs @2.5x "

			if (freshLogs.length > 0) {

				freshLogs.push({
					tfoot: true,
					timeIn: "Totals",
					timeDiff: totalDiff.toFixed(1),
					regular_hours: totalRegular.toFixed(2),
					overtime_hrs: overtime_combined,
					rowClasses: 'font-weight-bold'
				})
			}
		},

		getInitial(property) {
			if (typeof this.defaultFilterValues != 'undefined' && property in this.defaultFilterValues)
				return this.defaultFilterValues[property]
			else
				return null
		},
		decimalHoursToHHMM(hours) {
			let totalMinutes = Math.round(parseFloat(hours) * 60)

			if (isNaN(totalMinutes) || totalMinutes <= 0)
				return "00:00"

			let hrs = Math.floor(totalMinutes / 60)
			let mins = totalMinutes % 60

			return String(hrs).padStart(2, '0') + ':' + String(mins).padStart(2, '0')
		},
		getDetailedClaimName(claim, log) {
			if (claim.JobBidComponent && Object.keys(claim.JobBidComponent).length > 0) {
				let component = claim.JobBidComponent

				if (component.item_number)
					return component.item_number + ': ' + component.name

				return component.name || ""
			}

			if (claim.JobChangeOrder && Object.keys(claim.JobChangeOrder).length > 0 && log.Job && log.Job.job_num)
				return 'CO-' + log.Job.job_num + '-' + claim.JobChangeOrder.quote_num

			return ""
		},
		formatDetailedClaimForExport(claim, log) {
			let name = this.getDetailedClaimName(claim, log)
			let parts = ['Reg. Hrs ' + this.decimalHoursToHHMM(claim.regular_hours)]

			if (this.$store.timeLogSettings.uses_overtime_15x == 1)
				parts.push('OT1.5x Hrs ' + this.decimalHoursToHHMM(claim.overtime_hours_15x))
			if (this.$store.timeLogSettings.uses_overtime_2x == 1)
				parts.push('OT2x Hrs ' + this.decimalHoursToHHMM(claim.overtime_hours_2x))
			if (this.$store.timeLogSettings.uses_overtime_25x == 1)
				parts.push('OT2.5x Hrs ' + this.decimalHoursToHHMM(claim.overtime_hours_25x))

			return '"' + name + '" - (' + parts.join(' ') + ')'
		},
		detailedClaimColumnLabel(claimIndex) {
			let parts = ['Reg. Hrs HH:MM']

			if (this.$store.timeLogSettings.uses_overtime_15x == 1)
				parts.push('OT1.5x Hrs HH:MM')
			if (this.$store.timeLogSettings.uses_overtime_2x == 1)
				parts.push('OT2x Hrs HH:MM')
			if (this.$store.timeLogSettings.uses_overtime_25x == 1)
				parts.push('OT2.5x Hrs HH:MM')

			return 'Component/Change Order ' + claimIndex + ' - (' + parts.join(' ') + ')'
		},
		getMaxDetailedClaimsCount(logs) {
			let max = 0

			logs.forEach(log => {
				if (log.tfoot)
					return

				if (log.TimeLogDetailedClaim && log.TimeLogDetailedClaim.length > max)
					max = log.TimeLogDetailedClaim.length
			})

			return max
		},
		exportLogs() {
			let vm = this

			let fields = this.mutatedFields
			vm.exportingLogs = true

			this.fetchAllTimeLogs().then(allTimeLogs => {

				if (allTimeLogs) {

					vm.mutateLogs(allTimeLogs)

					let maxDetailedClaims = vm.getMaxDetailedClaimsCount(allTimeLogs)
					let headerRow = fields.map(field => field.label)

					for (let claimIndex = 1; claimIndex <= maxDetailedClaims; claimIndex++)
						headerRow.push(vm.detailedClaimColumnLabel(claimIndex))

					let rows = allTimeLogs.map(row => {
						let renderedRow = []
						fields.forEach(field => {
							if (!row[field.key])
								renderedRow.push("")
							else if (field.key == 'userFullName')
								renderedRow.push(row.userFullName ? row.userFullName.text : "")
							else if (field.key == 'wasOnsite') {
								renderedRow.push(row.onsiteBoolean ? "Yes" : "No")
							} else
								renderedRow.push(row[field.key])
						})

						if (maxDetailedClaims > 0) {
							let claims = row.TimeLogDetailedClaim || []

							for (let claimIndex = 0; claimIndex < maxDetailedClaims; claimIndex++) {
								if (claims[claimIndex])
									renderedRow.push(vm.formatDetailedClaimForExport(claims[claimIndex], row))
								else
									renderedRow.push("")
							}
						}

						return renderedRow
					})

					rows.unshift(headerRow)

					let filename = "TimeLogs.csv"

					this.exportToCSV(filename,rows)

				} else {
					vm.alertFail('Time Logs could not be exported.')
				}

				vm.exportingLogs = false
			})
		},
		fetchAllTimeLogs() {

			let exportIncludes = this.cloneObj(this.timeLogIncludes)
			exportIncludes.push({
				model: "TimeLogDetailedClaim",
				include: ["JobBidComponent", "JobChangeOrder"]
			})

			let promises = []
			for (let i = 1; i <= this.numPages; i++) {
				const params = {
					filters: this.compileFilters(),
					include: exportIncludes,
					orders: [["time_in","DESC"]],
					page: i
				}
				promises.push(this.getJSON('TimeLog/get', params))
			}

			return new Promise(resolve => {
				Promise.all(promises).then(responses => {
					let timelogs = []
					let allValid = true

					responses.forEach(response => {
						if (response.success)
							timelogs = timelogs.concat(response.data)
						else
							allValid = false
					})

					if (allValid)
						resolve(timelogs)
					else
						resolve(false)
				})
			})
		},
		editRecord(record) {
			this.editModal.viewMode = false
			this.editModal.visible = true
			this.editModal.record = record
			this.editModal.payload = {
				id: record.id,
				user_id: record.user_id,
				job_id: record.job_id,
				service_id: record.service_id,
				tenant_id: record.tenant_id,
				regular_hours: record.regular_hours,
				overtime_hours_15x: record.overtime_hours_15x,
				overtime_hours_2x: record.overtime_hours_2x,
				overtime_hours_25x: record.overtime_hours_25x
			}

		},
		viewTimeLog(record, action) {
			if (action == "viewTimeLog") {
				this.editModal.visible = true
				this.editModal.record = record
				this.editModal.viewMode = true
			}
		},
		save(payload) {
			let vm = this

			this.saveRecord("TimeLog",payload,response => {
				vm.fetchTimeLogs()
			})

			this.editModal.visible = false;
		},
		pageChange(newPage) {
			this.page = newPage

			this.fetchTimeLogs()
		},
		fetchOptions() {
			let vm = this

			let jobFilters = [
				["archived",0]
			]

			let userFields = JSON.stringify(["first_name","last_name"])

			let promises = [
				this.getJSON("EmployeeClassification/get"),
				this.getJSON("User/get?fields="+userFields),
				this.getJSON("TimeLogSetting/get"),
				this.fetchCustomers(true)
			]

			if (this.$store.projects.length == 0 && (this.serviceId == 0 || this.needToFetchDirectLog))
				promises.push(this.fetchJobs([],false,["job_name","job_num"]))

			Promise.all(promises).then(responses => {
				vm.classificationsOptions = vm.optionify(responses[0].data,"title")

				vm.employeesOptions = vm.optionify(responses[1].data.map(user => {
					user.fullName = user.first_name+" "+user.last_name

					return user
				}),"fullName")

				if (responses[2].data.length > 0) {

					vm.$store.timeLogSettings = responses[2].data[0]
				}
				else {

					vm.$store.timeLogSettings = {
						uses_overtime_15x: false,
						uses_overtime_2x: false,
						uses_overtime_25x: false,
						interval: null,
						intitial_payday: null
					}
				}

				// Wait a tick so parent defaultDateFromFilter can recompute from timeLogSettings
				vm.$nextTick(() => {
					if (!vm.filterValueSet && typeof vm.defaultFilterValues != 'undefined') {
						Object.keys(vm.defaultFilterValues).forEach(key => {
							vm.filterValues[key] = vm.defaultFilterValues[key]
						})
						vm.filterValueSet = true
					}

					vm.filterDefaultsReady = true

					if (!vm.blockFetches)
						vm.fetchTimeLogs()
				})

			})
		},
		fetchDirectLog(slug) {
			let vm = this

			let params = {
				include: this.timeLogIncludes
			}

			let promises = [
				this.getJSON("TimeLog/find/"+slug,params,true)
			]

			this.spinner(true)

			//fetch lists of projects/services to populate select
		//	if (this.$store.projects.length == 0)
			//	promises.push(this.fetchJobs([],false,["job_name","job_num"]))

			//if (this.$store.services.length == 0)
			//	promises.push(this.fetchServices([],false,["job_name","job_num","customer_id"]))

			promises[0].then(response => {
				
				if (response.success) {
					vm.editModal.visible = true
					vm.editModal.record = response.data
				}
			})

			Promise.all(promises).then(responses => {
				vm.spinner(false)
			})
		},
		fetchTimeLogs(){

			this.spinner(true)
			this.loading = true
			let vm = this

			this.$nextTick(function(){
				//set it inside a nexttick so the changed value can update

				let params = {
					filters: vm.compileFilters(),
					include: vm.timeLogIncludes,
					orders: [["time_in","DESC"]],
					page: this.page
				}

				vm.getJSON("TimeLog/get",params,true).then(response => {

					if (response.success) {
						vm.timeLogs = response.data

						if (vm.filterValues.classification_id) {

							//filter by classification after request
							vm.timeLogs = vm.timeLogs.filter(log => {

								if (log.User.EmployeeClassification[0].classification_id != vm.filterValues.classification_id)
									return false

								return true
							})
						}
						if (vm.filterValues.onSiteStatus != "all") {

							//filter by classification after request
							vm.timeLogs = vm.timeLogs.filter(log => {

								let distance = this.getDistance(log.Job.lat,log.Job.long,log.lat,log.long)

								if (distance > log.Job.check_in_tolerance && vm.filterValues.onSiteStatus == "onsite")
									return false
								else if (distance <= log.Job.check_in_tolerance && vm.filterValues.onSiteStatus == "offsite")
									return false

								return true
							})
						}

						if ("meta" in response) {
							vm.numPages = response.meta.num_pages
							vm.totalRecords = response.meta.num_results
						}
						else {
							vm.numPages = 1
							vm.totalRecords = response.data.length
						}

						vm.mutateLogs(vm.timeLogs)
					}

					vm.spinner(false)
					this.loading = false

				})
			})
		}
	},
	created() {
		this.fetchOptions()
		let vm = this

		let jobType, jobId
		if (this.projectId > 0) {
			jobType = "project"
			jobId = this.projectId
		}
		else if (this.serviceId > 0) {
			jobType = "service"
			jobId = this.serviceId
		}

		this.fetchUserRoles(this.$store.userDetails.id,jobType,jobId,["JobPersonnelRole"]).then(response => {
			if (response.success)
				vm.userRoles = response.data
		})

		// fetchTimeLogs is deferred until fetchOptions loads timeLogSettings
		// and defaultFilterValues.dateFrom can use the pay period start

		//check if a there is a direct link to a record
		if (this.needToFetchDirectLog) {
			this.fetchDirectLog(this.$route.params.slug)
		}

		this.$bus.$on('timeLogSaved', () => {
			this.fetchTimeLogs()
		})
	}

}
</script>
